import Frames from "@frog/source/engine/animating/Frames.js"

export default {
    "static": require("./eyes-1.png"),
    "idle": {
        "frames": Frames.run({
            "tweentime": 40,
            "images": [
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-7.png"),
                require("./eyes-6.png"),
                require("./eyes-5.png"),
                require("./eyes-4.png"),
                require("./eyes-3.png"),
                require("./eyes-2.png"),
                require("./eyes-1.png"),
                require("./eyes-1.png"),
                require("./eyes-1.png"),
                require("./eyes-2.png"),
                require("./eyes-3.png"),
                require("./eyes-4.png"),
                require("./eyes-5.png"),
                require("./eyes-6.png"),
            ]
        })
    },
}
